import fields from '@/sui/data/sheets/edit/fields'

function buildContext (field, value) {
  return () => {
    const result = {}
    result[field] = value
    return result
  }
}

export default {
  p1: buildContext(fields.obsManagment, 1),
  p2: buildContext(fields.obsManagment, 2),
  p3: buildContext(fields.obsManagment, 3),
  p4: buildContext(fields.obsManagment, 6),
  p5: buildContext(fields.obsManagment, 8),
  b1: buildContext(fields.obsManagment, 4),
  b2: buildContext(fields.obsManagment, 5),
  r1: buildContext(fields.obsManagment, 7)
}
